<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Alle Meetings</h5>
              </div>
              <div v-if="requireAdmin" class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link
                      class="mb-0 btn bg-gradient-success btn-sm"
                      target="_blank"
                      :to="{name: 'New Meeting'}"
                  >Neues Meeting
                  </router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <table id="meeting-list" ref="meetingList" class="table table-flush">
                <thead class="thead-light">
                <tr>
                  <th title="image"></th>
                  <th title="meeting">Meeting</th>
                  <th title="referent">Referent</th>
                  <th title="description">Beschreibung</th>
                  <th title="progress">Fortschritt</th>
                  <!--th>Stichwörter</th-->
                  <th title="action">Action</th>
                </tr>
                </thead>
                <tbody class="text-sm"></tbody>
                <tfoot>
                <tr>
                  <th></th>
                  <th>Meeting</th>
                  <th>Referent</th>
                  <th>Beschreibung</th>
                  <th>Fortschritt</th>
                  <!--th>Stichwörter</th-->
                  <th>Action</th>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="ms-3">
              <p>
                Zeige {{ pagination?.from }} bis {{ pagination?.to }} von
                {{ pagination?.total }} Einträgen
              </p>
            </div>
            <BasePagination
                class="pagination-success pagination-md me-3"
                :per-page="pagination?.perPage"
                :value="pagination?.currentPage"
                :total="pagination?.total"
                @click="getDataFromPage($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DataTable} from "simple-datatables";
import BasePagination from "@/components/BasePagination.vue";
import eventTable from "@/mixins/eventTable";
import store from "/src/store";
import _ from "lodash";

var currentQuery = "";
var currentPerPage = 5;
var currentPage = 1;
var currentSort = "id";
var loading = require("/src/assets/img/loading.gif");

const getMeetingList = _.debounce(async function (params) {
  await store.dispatch("meetings/getMeetings", {
    query: params.query,
    sort: params.sort,
    currentPerPage: params.currentPerPage,
    currentPage: params.currentPage,
  });
}, 300);

export default {
  name: "MeetingsList",
  components: {BasePagination},
  mixins: [eventTable],
  data() {
    return {
      meetingsAux: [],
      pagination: {},
      tableItems: null,
    };
  },
  computed: {
    profile() {
      return this.$store.getters["profile/profile"];
    },
    meetingsList() {
      return this.$store.getters["meetings/meetings"]?.data;
    },
    progressList() {
      return this.$store.getters["meetings/meetingsProgress"];
    },
    metaPage() {
      return this.$store.getters["meetings/meetings"]?.meta;
    },
    requireAdmin() {
      if (this.$store.getters["auth/loggedIn"] && this.profile) {
        if (this.profile.scope == 2) return true;
      }
      return false;
    },
  },
  watch: {
    metaPage: {
      handler: "reactivePagination",
      immediate: false,
      deep: true,
    },
    meetingsList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async created() {

    if (this.$store.getters["auth/loggedIn"]) {
      try {
        await this.$store.dispatch("profile/getProfile");
        this.profileChange = {...this.profile};
      } catch (error) {
        try {
          await this.$store.dispatch("auth/logout");
        } finally {
          await this.$router.push("/login");
        }
      }
    }
  },
  async mounted() {
    if (this.$refs.meetingList) {
      this.tableItems = new DataTable(this.$refs.meetingList, {
        fixedHeight: false,
        perPage: 5,
      });

      document.querySelector(".dataTable-bottom").remove();
      this.tableItems.label = null;
      this.tableItems.setMessage(
          `<img src="${loading}" width="100" height="100" alt="loading" />`
      );

      await getMeetingList({
        query: currentQuery,
        currentPerPage: currentPerPage,
        currentPage: currentPage,
        sort: currentSort,
      });

      this.tableItems.on("datatable.perpage", async function (perpage) {
        this.setMessage(
            `<img src="${loading}" width="100" height="100" alt="loading" />`
        );
        await getMeetingList({
          query: currentQuery,
          currentPerPage: (currentPerPage = perpage),
          currentPage: (currentPage = 1),
          sort: currentSort,
        });
      });

      this.tableItems.on("datatable.search", async function (query) {
        this.setMessage(
            `<img src="${loading}" width="100" height="100" alt="loading" />`
        );
        await getMeetingList({
          query: (currentQuery = query),
          currentPerPage: currentPerPage,
          currentPage: currentPage,
          sort: currentSort,
        });
      });
    }
  },

  beforeUnmount() {
    currentQuery = "";
    currentPerPage = 5;
    currentPage = 1;
    currentSort = "id";
  },

  methods: {
    generateActions(rowId) {
      let actions = "";
      if (this.requireAdmin) {
        actions = this.actionShowButton(rowId, "Meeting anzeigen") +
            this.actionEditButton(rowId, "Meeting bearbeiten") +
            this.actionDeleteButton(rowId, "Meeting löschen");
      } else {
        actions = this.actionShowButton(rowId, "Meeting anzeigen");
      }
      return actions;
    },
    async getDataFromPage(page) {
      await getMeetingList({
        query: currentQuery,
        currentPerPage: currentPerPage,
        currentPage: (currentPage = page),
        sort: currentSort,
      });
    },

    shortenText(text, maxLength) {
      if (text && text.length > maxLength) {
        // remove html tags
        text = text.replace(/(<([^>]+)>)/gi, "");
        return text.slice(0, maxLength) + "...";
      }

      if (text === null || text === undefined || text === "" || text === "<p><br></p>") {
        return "Keine Beschreibung vorhanden";
      }

      return text;
    },

    async reactivePagination() {
      this.pagination = this.metaPage;
    },
    getProgressAmount(row) {
      if (row.videoComplete) {
        return 100;
      }
      return row.progress;
    },


    async reactiveTable() {
      this.meetingsAux = [];
      if (this.meetingsList?.length > 0) {
        this.meetingsAux = await Promise.all(this.meetingsList.map(async (row) => {
          const progress = await store.dispatch("meetings/getMeetingProgress", row.id);
          // eslint-disable-next-line require-atomic-updates
          row.progress = progress.data.progress;
          // eslint-disable-next-line require-atomic-updates
          row.videoComplete = progress.data.completed;
          const progressAmount = this.getProgressAmount(row);

          return [
            `<img src="${row.thumbnailUrl}" id="${row.id}" class="actionButton showImage" style="width: 100px; cursor: pointer" alt="meeting-thumbnail"/>`,
            row.meetingName,
            row.referent ? row.referent : "Kein Referent",
            this.shortenText(row.description, 80),
            this.videoProgressBar(progressAmount),
            this.generateActions(row.id),
          ];
        }));

        this.tableItems.data = [];
        this.tableItems.refresh();
        document.querySelector(".dataTable-input").value = currentQuery;
        this.tableItems.insert({data: this.meetingsAux});
        this.removeEvent();
        this.eventToCall({
          table: this.tableItems,
          showPath: "Meeting",
          redirectPath: "Edit Meeting",
          deletePath: "meetings/deleteMeeting",
          getPath: "meetings/getMeetings",
          textDelete: "Meeting wurde erfolgreich gelöscht!",
          textDefaultData: "meetings",
          params: {
            query: currentQuery,
            currentPerPage: currentPerPage,
            currentPage: currentPage,
            sort: currentSort,
          },
        });
      } else {
        this.tableItems.setMessage("Keine Meetings gefunden");
      }
    },

    handleMeetingClick(meetingId) {
      this.$router.push({ name: 'Meeting', params: { id: meetingId } });
    }

  },
};
</script>
